import { DateUtils } from '@broker/utils';
import { BasePath } from 'constants/basePath';
import React, { useEffect, useState } from 'react';
import { axiosInstance } from 'services/axios';
import { getDirectusImg } from 'services/graphql/directus';
import { EventType, NewsType } from 'types';

import { DLink, ImagePreset, SvgUse } from '@dnse/ui';


interface Props {
  originPost: NewsType | EventType;
  postType: string;
  relatedPosts: NewsType[] | EventType[];
  totalCountRelatedPosts: number;
}

const DEFAULT_LIMIT = 3;

export const RelatedPosts: React.FC<Props> = ({
  originPost,
  postType,
  relatedPosts,
  totalCountRelatedPosts
}) => {
  const { id, hashtag } = originPost;
  const relatedHashtagArray = hashtag.map(
    hashtagItem => hashtagItem.hashtag_id.name
  );

  const [page, setPage] = useState<number>(2);
  const [posts, setPosts] = useState<EventType[] | NewsType[]>(relatedPosts);
  const [postBasePath, setPostBasePath] = useState<string>('');

  useEffect(() => {
    switch (postType) {
      case 'news': {
        setPostBasePath(BasePath.NewsBasePath);
        break;
      }
      case 'events': {
        setPostBasePath(BasePath.EventsBasePath);
        break;
      }
      case 'blogs': {
        setPostBasePath(BasePath.BlogsBasePath);
        break;
      }
      default: {
        break;
      }
    }
  }, []);

  const getMoreRelatedPost = async () => {
    const apiUrl = `api/${postType}/${id}`;
    await axiosInstance
      .post(apiUrl, {
        relatedHashtagArray,
        id,
        limit: DEFAULT_LIMIT,
        page
      })
      .then(data => {
        setPosts([...posts, ...data.data[postType]]);
        setPage(page + 1);
      })
      .catch(error => console.log(error));
  };

  const shouldShowGetMoreButton =
    totalCountRelatedPosts > (page - 1) * DEFAULT_LIMIT;

  return (
    <div data-testid="related-post-area">
      <div className="flex items-center gap-2">
        <div className="min-w-[3px] h-[35px] bg-brand-300 rounded-t-[100px]" />
        <h3 className="text-xl font-medium">Bài viết liên quan</h3>
      </div>
      <div className="py-4" >
        {posts.map((post: NewsType | EventType, index: number) => (
          <div key={post.id} data-testid="related-post" className={index !==0 && "mt-[30px]"}>
            <div className="animate-fadeIn">
              <div
                className={
                  'block md:flex md:max-h-[110px] overflow-hidden gap-8 flex-row-reverse justify-between'
                }
              >
                <div className="md:basis-[27%] mb-2 md:mb-0">
                  <DLink href={`${postBasePath}/${post.slug}`}>
                    <div
                      className={
                        'max-h-[200px] md:h-[110px] overflow-hidden rounded'
                      }
                    >
                      <ImagePreset
                        src={getDirectusImg(post.cover_image)}
                        alt={post.title}
                        className="rounded"
                        loading="eager"
                      />
                    </div>
                  </DLink>
                </div>
                <div className="md:basis-[73%]">
                  <div className="flex mb-1 gap-1.5"></div>
                  <DLink href={`${postBasePath}/${post.slug}`}>
                    <p className="text-base font-medium mb-2">{post.title}</p>
                  </DLink>
                  <div className="text-gray-700 text-[13px] font-normal flex items-center gap-x-1">
                    <SvgUse
                      id="outline-clock"
                      height={12}
                      width={12}
                      className="mt-[2px]"
                    />
                    <time>
                      {DateUtils.formatDate(post.date_created, 'DD/MM/YYYY')}
                    </time>
                  </div>
                  <div>
                    <p className="text-xs text-gray-100 line-clamp-3">
                      {post.sapo}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {index !== posts.length - 1 && (
              <div className="hidden md:block h-[1px] bg-gray-950 my-4" />
            )}
          </div>
        ))}
      </div>
      {shouldShowGetMoreButton && (
        <div className="flex justify-center mt-[14px]">
          <button
            className="w-[200px] h-[38px] flex justify-center items-center text-brand-300 font-medium text-base px-[24px] py-[8px] lg:py-[14px] rounded-[41px] border-[1px] border:solid border-brand-300"
            onClick={getMoreRelatedPost}
          >
            Xem thêm
          </button>
        </div>
      )}
    </div>
  );
};
